'use strict';

// Helpers
const loaderInstance = require('../../loaderHelper');
const lpmPaymentProcessingHelper = require('../helpers/lpmPaymentProcessorHelper');

const LpmAlertHandlerModel = require('../alerthandler/lpmAlertHandlerModel');
const helper = require('../../helper');
const alertHandler = new LpmAlertHandlerModel();
const lpmModel = require('../braintreesdk/braintreeLpmModel');

/**
 * Opens LPM page and process a payment
 * @param {Object} reqData Options object
 * @param {string} paymentMethodName Payment method name
 * @param {Object} configs Local payment methods configs
 */
function startLpmPayment(reqData, paymentMethodName, configs) {
    const lpmLoaderEl = lpmPaymentProcessingHelper.getLpmLoaderContainer(paymentMethodName);
    const loader = loaderInstance(lpmLoaderEl);

    lpmModel.startPayment(reqData)
        .then(function(startPaymentPayload) {
            // Handles LPM processing messages on the Billing-Checkout Page
            alertHandler.hideAlerts();
            alertHandler.showInfo(alertHandler.alertMessages.LPM_PAYMENT_SUCCESS);

            // Sends payment details to the backend
            return lpmPaymentProcessingHelper.confirmPayment(configs,
                paymentMethodName,
                reqData.email,
                startPaymentPayload);
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            lpmPaymentProcessingHelper.processLpmConfirmForm(data.redirectUrl);
            loader.hide();
        })
        .catch(function(error) {
            loader.hide();
            alertHandler.handleLpmError(error);
        });
}

/**
 * Prepares and checks all necessary options for start LPM payment
 * @param {string} fundingSource Local payment method's funding source
 * @param {Object} configs Local payment methods configs
 * @param {Object} event On LPM button click event
 */
function onLpmButtonClick(fundingSource, configs) {
    const billingFormEl = document.getElementById('dwfrm_billing');
    const emailEl = document.querySelector('.customer-summary-email');
    const lpmLoaderEl = lpmPaymentProcessingHelper.getLpmLoaderContainer(fundingSource);
    const loader = loaderInstance(lpmLoaderEl);

    alertHandler.hideAlerts();

    try {
        if (!helper.validateForm(billingFormEl)) {
            throw new Error(configs.messages.INVALID_BILLING);
        }

        if (configs.options.amount === 0) {
            loader.hide();
            alertHandler.handleZeroAmountOnCheckoutError(fundingSource);
        }

        fetch(helper.getUrlWithCsrfToken(configs.getOrderInfoUrl))
            .then((response) => response.json())
            .then((data) => {
                loader.show();
                alertHandler.showInfo(alertHandler.alertMessages.LPM_PAYMENT_PROCESSING);

                // Updates shipping address and amount of order from server
                lpmModel.updateLpmOrderData(data.shippingAddress, data.amount);

                // Creates all options for initiating the local payment payment flow.
                const reqData = lpmModel.createRequestData(fundingSource, emailEl.textContent, configs);

                startLpmPayment(reqData, fundingSource, configs);
            })
            // Handles errors form Braintree-GetOrderInfo endpoint
            .catch((error) => {
                loader.hide();
                alertHandler.showError(error.responseJSON.message);
            });
        loader.hide();
    } catch (error) {
        alertHandler.showError(error);
    }
}

module.exports = {
    onLpmButtonClick,
    startLpmPayment
};
